/** Draws with currentColor: the caller sets the ink (a token), e.g. the
 *  info-row icon slot in UserBannerInfoRow.css. */
export const CityIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M10 2L3 7v15h14V7l-7-5zm0 2.18l6 4.28v11.54H4V8.46l6-4.28zM6 9h12v2H6V9zm0 4h12v2H6v-2zm0 4h8v2H6v-2z"
        fill="currentColor"
        opacity="0.7"
      />
    </svg>
  );
};

